import Vue from "vue";
import VueRouter from "vue-router";
import GlobalMixin from "@/mixins/global-mixin";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/offers",
  },
  {
    path: "/offers",
    name: "offers",
    meta: { acl: ["manager", "admin"] },
    component: () => import("@/views/offers/index.vue"),
  },
  {
    path: "/create",
    name: "create",
    meta: { acl: ["manager", "admin"] },
    component: () => import("@/views/create/index.vue"),
  },
  {
    path: "/permissions",
    name: "permissions",
    meta: { acl: ["admin"] },
    component: () => import("@/views/permissions/index.vue"),
  },
  {
    path: "/offer/:id",
    name: "offer",
    meta: { acl: ["manager", "admin"] },
    props(route) {
      return {
        id: route.params.id,
      };
    },
    component: () => import("@/views/offer/index"),
  },
  {
    path: "/user/:id",
    name: "user",
    meta: { acl: ["manager", "admin"] },
    props(route) {
      return {
        id: route.params.id,
      };
    },
    component: () => import("@/views/user/index"),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  const check = to.matched.some((route) =>
    GlobalMixin.methods.hasRoleAccess(route.meta.acl)
  );
  if (check) {
    return next();
  } else if (to.path !== "/offers") {
    return next({ name: "offers", query: { redirect: to.from } });
  }
  next();
});

export default router;
